"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ICalWeekday = exports.ICalEventRepeatingFreq = void 0;
var ICalEventRepeatingFreq;
(function (ICalEventRepeatingFreq) {
    ICalEventRepeatingFreq["SECONDLY"] = "SECONDLY";
    ICalEventRepeatingFreq["MINUTELY"] = "MINUTELY";
    ICalEventRepeatingFreq["HOURLY"] = "HOURLY";
    ICalEventRepeatingFreq["DAILY"] = "DAILY";
    ICalEventRepeatingFreq["WEEKLY"] = "WEEKLY";
    ICalEventRepeatingFreq["MONTHLY"] = "MONTHLY";
    ICalEventRepeatingFreq["YEARLY"] = "YEARLY";
})(ICalEventRepeatingFreq = exports.ICalEventRepeatingFreq || (exports.ICalEventRepeatingFreq = {}));
var ICalWeekday;
(function (ICalWeekday) {
    ICalWeekday["SU"] = "SU";
    ICalWeekday["MO"] = "MO";
    ICalWeekday["TU"] = "TU";
    ICalWeekday["WE"] = "WE";
    ICalWeekday["TH"] = "TH";
    ICalWeekday["FR"] = "FR";
    ICalWeekday["SA"] = "SA";
})(ICalWeekday = exports.ICalWeekday || (exports.ICalWeekday = {}));
//# sourceMappingURL=types.js.map